import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import "./style.css";
interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isNetScreen: boolean;
  isCombine?: boolean;
}

const NormalizationModal = ({
  isOpen,
  setIsOpen,
  isNetScreen,
  isCombine,
}: Props) => {
  const titleModal = "Normalization Info";
  let contentModal = "Normalized data is not available for this session.";
  if (isNetScreen) {
    contentModal =
      "When hitting into a Net or Screen, all data is considered Normalized. You can only switch between Actual and Normalized data for Outdoor sessions with full ball flight.";
  }
  // KWSA-34: a Combine session can never toggle normalization, whatever its location
  // (GetNormalizedState always returns a fixed state for Combine), so this message
  // takes precedence over both the Net/Screen and the not-available copy.
  if (isCombine) {
    contentModal =
      "When running a Combine, you are unable to toggle normalization on or off. You can only switch between Actual and Normalized data for Outdoor practice sessions with full ball flight.";
  }
  return (
    <Modal
      open={isOpen}
      onClose={() => setIsOpen(false)}
      center
      closeIcon={<img alt="close icon" src="/img/fs_icon-close.svg" />}
    >
      <div className="normalization-modal-wrap">
        <div className="normalization-modal-header">
          <div className="title">{titleModal}</div>
        </div>
        <div className="normalization-modal-content">{contentModal}</div>
        <div className="normalization-modal-footer">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setIsOpen(false)}
          >
            Got it!
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default NormalizationModal;
